export default {
  tab: {
    'rendering-engine': 'Rendering-Engine',
    'barcode-scanner': 'Barcodescanner',
    'api-explorer': 'API-Explorer',
  },
};
